export const separate = (string) => {
    let words = string.split(" ")
    return words[words.length - 1]
}